import store from '@/store/index';

export default {
  // enable/disable microphone
  toggleMic(state) {
    if (store.getters.isWarmUpPeriod ) {
      return;
    }

    this.enableAudio = state;
    if (this.localAudioTrack) {
      this.localAudioTrack.getMediaStreamTrack().enabled = state;
    }
  }
}

